export default {
  inputEmpty: {
    zh_cn: '请输入内容',
    en: 'Please enter content',
    zhhant: '請輸入內容',
    he: 'אנא הזן תוכן',
    de: 'Bitte Inhalt eingeben',
    es: 'Por favor ingrese contenido',
    ru: 'Пожалуйста, введите содержание',
    vi: 'Vui lòng nhập nội dung',
  },
  inputInvalid: {
    zh_cn: '请输入有效内容',
    en: 'Please enter a valid input',
    zhhant: '請輸入有效內容',
    he: 'אנא הזן קלט תקני',
    de: 'Bitte geben Sie einen gültigen Wert ein',
    es: 'Por favor ingrese un valor válido',
    ru: 'Пожалуйста, введите корректное значение',
    vi: 'Vui lòng nhập một giá trị hợp lệ',
  },
  inputFormatError: {
    zh_cn: '输入格式错误',
    en: 'Input format error',
    zhhant: '輸入格式錯誤',
    he: 'שגיאה בפורמט הקלט',
    de: 'Eingabeformatfehler',
    es: 'Error en el formato de entrada',
    ru: 'Ошибка формата ввода',
    vi: 'Lỗi định dạng đầu vào',
  },
  selectNone: {
    zh_cn: '请选择一个选项',
    en: 'Please select an option',
    zhhant: '請選擇一個選項',
    he: 'אנא בחר אפשרות',
    de: 'Bitte wählen Sie eine Option',
    es: 'Por favor seleccione una opción',
    ru: 'Пожалуйста, выберите вариант',
    vi: 'Vui lòng chọn một tùy chọn',
  },
  inputRangeInvalid: {
    zh_cn: '有效值范围：{min} ~ {max}',
    en: 'Valid value range: {min} ~ {max}',
    zhhant: '有效值範圍：{min} ~ {max}',
    he: 'טווח ערך תקני: {min} ~ {max}',
    de: 'Gültiger Wertebereich: {min} ~ {max}',
    es: 'Rango de valor válido: {min} ~ {max}',
    ru: 'Диапазон корректного значения: {min} ~ {max}',
    vi: 'Phạm vi giá trị hợp lệ: {min} ~ {max}',
  },
  stringLengthInvalid: {
    zh_cn: '有效字符长度范围：{min} ~ {max} 个字符',
    en: 'Valid character length range: {min} ~ {max} characters',
    zhhant: '有效字元長度範圍：{min} ~ {max} 個字元',
    he: 'טווח אורך תו תקני: {min} ~ {max} תווים',
    de: 'Gültiger Zeichenlängenbereich: {min} ~ {max} Zeichen',
    es: 'Rango de longitud de caracteres válido: {min} ~ {max} caracteres',
    ru: 'Диапазон длины корректных символов: от {min} до {max} символов',
    vi: 'Phạm vi độ dài ký tự hợp lệ: {min} ~ {max} ký tự',
  },
  minStringLength: {
    zh_cn: '最小字符长度：{minLen} 个字符',
    en: 'Minimum length: {minLen} characters',
    zhhant: '最小字元長度：{minLen} 個字元',
    he: 'אורך מינימלי: {minLen} תווים',
    de: 'Mindestlänge: {minLen} Zeichen',
    es: 'Longitud mínima: {minLen} caracteres',
    ru: 'Минимальная длина: {minLen} символов',
    vi: 'Độ dài tối thiểu: {minLen} ký tự',
  },
  maxStringLength: {
    zh_cn: '最大字符长度：{maxLen} 个字符',
    en: 'Maximum length: {maxLen} characters',
    zhhant: '最大字元長度：{maxLen} 個字元',
    he: 'אורך מרבי: {maxLen} תווים',
    de: 'Maximale Zeichenlänge: {maxLen} Zeichen',
    es: 'Longitud máxima: {maxLen} caracteres',
    ru: 'Максимальная длина: {maxLen} символов',
    vi: 'Độ dài tối đa: {maxLen} ký tự',
  },
  stringLengthExact: {
    zh_cn: '有效字符长度：{len} 个字符',
    en: 'Valid character length: {len} characters',
    zhhant: '有效字元長度：{len} 個字元',
    he: 'אורך התו התקני: {len} תווים',
    de: 'Gültige Zeichenlänge: {len} Zeichen',
    es: 'Longitud de caracteres válida: {len} caracteres',
    ru: 'Корректная длина символа: {len} символов',
    vi: 'Độ dài ký tự hợp lệ: {len} ký tự',
  },
  maxDecimalPlaces: {
    zh_cn: '最大小数位数：{maxDecimalPlaces} 位',
    en: 'Maximum decimal places: {maxDecimalPlaces} digits',
    zhhant: '最大小數位數：{maxDecimalPlaces} 位',
    he: 'מספר ספרות אחרי נקודה: {maxDecimalPlaces} ספרות',
    de: 'Maximale Dezimalstellen: {maxDecimalPlaces} Stellen',
    es: 'Número máximo de decimales: {maxDecimalPlaces} cifras',
    ru: 'Максимальное количество знаков после запятой: {maxDecimalPlaces} знаков',
    vi: 'Số chữ số thập phân tối đa: {maxDecimalPlaces} chữ số',
  },
  minCurrentLessThanMaxCurrent: {
    zh_cn: '最小电流要小于最大电流',
    en: 'The minimum current must be less than the maximum current',
    zhhant: '最小電流要小於最大電流',
    he: 'הזרם המינימלי חייב להיות פחות מהזרם המקסימלי',
    de: 'Der Mindeststrom muss kleiner als der Höchststrom sein',
    es: 'La corriente mínima debe ser menor que la corriente máxima',
    ru: 'Минимальный ток должен быть меньше максимального',
    vi: 'Dòng điện tối thiểu phải nhỏ hơn dòng điện tối đa',
  },
  discountRatioInfo: {
    zh_cn: '输入0-1之间的小数,输入0.1打一折,输入1不打折',
    en: 'Input a decimal between 0 and 1, input 0.1 for a 10% discount, and input 1 for no discount',
    zhhant: '輸入0-1之間的小數,輸入0.1打一折,輸入1不打折',
    he: 'הכנס מספר בין 0 ל-1, הכנס 0.1 למבחן של 10% וכנס 1 ללא הנחה',
    de: 'Geben Sie eine Dezimalzahl zwischen 0 und 1 ein, geben Sie 0.1 für eine 10%-Rabatt ein und geben Sie 1 für keine Rabatt ein',
    es: 'Ingrese un número decimal entre 0 y 1, ingrese 0.1 para un 10% de descuento e ingrese 1 para no descuento',
    ru: 'Введите десятичное число между 0 и 1, введите 0.1 для 10% скидки и введите 1 для без скидки',
    vi: 'Nhập một số thập phân giữa 0 và 1, nhập 0.1 cho một giảm giá 10% và nhập 1 để không giảm giá',
  },
}
